import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

export const ServicePolicyPage = () => {
	return (
		<PageMeta title="利用規約" url={generatePath(PATHS.POLICY.SERVICE_POLICY)}>
			<style>{`
				.bg-chillnn-bg-page {
					background-color: #f0f0f0; /* Example background color */
				}
				.px-5 {
					padding-left: 1.25rem; /* 20px */
					padding-right: 1.25rem; /* 20px */
				}
				.py-16 {
					padding-top: 4rem; /* 64px */
					padding-bottom: 4rem; /* 64px */
				}
				.mx-20 {
					margin-left: 5rem; /* 80px */
					margin-right: 5rem; /* 80px */
				}
				.text-sm {
					font-size: 0.875rem; /* 14px */
				}
				.pb-12 {
					padding-bottom: 3rem; /* 48px */
				}
				.text-center {
					text-align: center;
				}
				.text-xl {
					font-size: 1.25rem; /* 20px */
				}
				.font-semibold {
					font-weight: 600;
				}
				.subTitle {
					padding-top: 0.75rem; /* 12px */
					padding-bottom: 0.75rem; /* 12px */
					font-weight: 600;
					font-size: 1.125rem; /* 18px */
				}
				.paragraph {
					margin-top: 0.375rem; /* 6px */
					margin-bottom: 0.375rem; /* 6px */
				}
				.sub {
					margin-left: 1rem; /* Indent for sub-items */
				}
			`}</style>

			<div className="bg-bg-layer-500 px-5 py-16 text-sm lg:mx-20">
				<div className="pb-12 text-center text-xl font-semibold">
					<h1>利用規約</h1>
				</div>
				<div>
					<div>
						<p>
							本利用規約（以下「本規約」といいます。）は、株式会社CHILLNN（以下、「当社」といいます。）が運営する予約システム（以下「本サービス」といいます。）の提供条件および当社と登録ユーザーの皆さまとの間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいた上で、本規約に同意いただく必要があります。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第１条（適用）</h2>
						<p className="paragraph">
							1.
							本規約は、登録ユーザーと当社との間の本サービスの利用に係る一切の関係に適用されるものとします。
						</p>
						<p className="paragraph">
							2.
							当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
						</p>

						<p className="paragraph">
							3.
							本規約の規定が前条の個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り、本規定の規定が優先されるものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第２条（定義）</h2>
						<p className="paragraph">
							本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。
						</p>
						<p className="paragraph">
							1.
							「サービス利用契約」とは、本規約を契約条件として当社と登録ユーザーの間で締結される、本サービスの利用契約を意味します。
						</p>
						<p className="paragraph">
							2.
							「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。
						</p>
						<p className="paragraph">
							3.
							「掲載データ」とは、登録ユーザーが本サービスを利用して掲載その他送信するコンテンツ（文章、画像、動画その他のデータを含みますがこれらに限ります。）を意味します。
						</p>
						<p className="paragraph">4. 「当社」とは、株式会社CHILLNNを意味します。</p>
						<p className="paragraph">
							5.
							「登録ユーザー」とは、第３条に基づいて本サービスの利用者としての登録がなされた法人または個人を意味します。
						</p>
						<p className="paragraph">
							6.
							「本サービス」とは、当社が提供する宿泊予約サービスCHILLNNという名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は当該変更後のサービスを含みます。）を意味します。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第３条（利用登録と契約の成立）</h2>
						<p className="paragraph">
							利用者は本サービスを利用するにあたり、下記事項を保証するものとします
						</p>
						<p className="paragraph">
							1.
							本サービスにおいては、本サービスの利用を希望する者（以下、「登録希望者」といいます。）が本規約に同意の上、当社の定める一定の情報（以下「登録事項」といいます。）を当社の定める方法によって当社に提供することにより、当社に対し、本サービスに利用の登録を申請することができます。
						</p>
						<p className="paragraph">
							2.
							当社は、旅館業の認定を受けていることを前提として（宿泊を伴わない予約での利用の場合は、その限りではない）、当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に電子メールにて通知します。登録希望者の登録ユーザーとしての登録は、当社が本稿の通知を行なったことを持って完了したものとします。
						</p>
						<p className="paragraph">
							3.
							前項に定める登録の完了時に、サービス利用契約が登録ユーザーと当社の間に成立し、登録ユーザーは本サービスを本規約に従い利用することができるようになります。
						</p>
						<p className="paragraph">
							4.
							当社は、申請内容に関して、登録希望者に本人確認等のための資料の提出を求めることがあり、登録希望者はこれに応じるものとします。
						</p>
						<p className="paragraph">
							5.
							当社は、登録希望者が、以下の各号のいずれかの事由に該当する場合は、登録及び再登録を拒否することがあり、またその理由について一切開示義務を負いません。
						</p>
						<div className="sub">
							<p className="paragraph">
								5.1. 当社に提供した登録事項の全部または一部につき虚偽、誤記、または記載漏れがあった場合
							</p>
							<p className="paragraph">
								5.2 当社の指定する通りに本サービス利用のための手続きを行わなかった場合
							</p>
							<p className="paragraph">5.3 当社からの連絡に対し、14日間以上返答がない場合</p>
							<p className="paragraph">
								5.4
								未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合
							</p>
							<p className="paragraph">
								5.5
								反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずるものを意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行なっていると当社が判断した場合
							</p>
							<p className="paragraph">
								5.6 過去当社との契約に違反した者またはその関係者であると当社が判断した場合
							</p>
							<p className="paragraph">5.7 過去登録抹消措置を受けたことがある場合</p>
							<p className="paragraph">5.8 その他、登録を適当でないと当社が判断した場合</p>
						</div>
						<p className="paragraph">
							6.
							前項に基づき当社が利用登録の申請を拒否した場合、当社は、登録希望者に対し、設備投資、費用負担、逸失利益その他登録希望者に生じた損害につき一切責任を負わないものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第４条（登録事項の変更）</h2>
						<p className="paragraph">
							登録ユーザーは、登録事項に変更があった場合、当社所定の方法により当社に対し当該変更事項を直ちに通知するものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第５条（ユーザーIDおよびパスワードの管理）</h2>
						<p className="paragraph">
							1.
							登録ユーザーは、自己の責任において、本サービスに関するユーザーIDおよびパスワードを適切に管理するものとします。
						</p>
						<p className="paragraph">
							2.
							登録ユーザーがユーザーIDおよびパスワードの利用を許諾した者（以下、本条において「ID利用者」といいます。）により、ユーザーIDおよびパスワードの不正使用等があった場合、登録ユーザーが一切の責任を負うものとします。
						</p>
						<p className="paragraph">
							3.
							ID利用者は、本規約の適用を受けるものとし、ID利用者の行なった行為が本規約に違反する場合は、当社は本規約に基づいた対応を行うものとします。
						</p>
						<p className="paragraph">
							4.
							ユーザーIDおよびパスワードの管理不十分、使用上の過誤、第三者による使用等によって生じた損害に関する責任は登録ユーザーが負うものとします。
						</p>
						<p className="paragraph">
							5.
							当社は、IDおよびパスワードが不正に使用されていると判断した場合、登録ユーザーへの事前の通知なしに、登録ユーザーの会員資格を停止できるものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第６条（利用料金および支払方法）</h2>
						<p className="paragraph">
							1.登録ユーザーは、本サービス利用の対価として、当社が指定する利用料金を、当社が指定する方法にて当社に支払うものとします。利用料金は、契約成立日から発生するものとする。
							<br />
						</p>
						<div className="sub">
							<p className="paragraph">[利用料金]</p>
							<p className="paragraph">
								- 予約手数料3%もしくは所定の定額手数料を選んでいる場合は選択した定額手数料
							</p>
							<p className="paragraph">
								- 基本利用料金：10,000円/月、29,100円/3ヵ月、102,000円/1年のうち選択したもの
							</p>
							<p className="paragraph">- 事前決済手数料 2.9 ~ 3.3％と宿泊券の販売に関する発券手数料1%</p>
							<p className="paragraph">
								また、本サービスを通し行われた宿泊予約キャンセル時の手数料に関しては
								<a
									className="text-blue-600"
									href="https://prd-assets.chillnn.com/public/assets/uploads/documents/%E6%B1%BA%E6%B8%88%E6%89%8B%E6%95%B0%E6%96%99%E3%81%A8%E3%82%AD%E3%83%A3%E3%83%B3%E3%82%BB%E3%83%AB%E6%96%99.pdf"
								>
									こちら
								</a>
								をご参照ください。
							</p>
						</div>
						<p className="paragraph">
							2.
							当社は、本サービスの内容の変更、事業上の理由、法令の制定改廃、経済状況の変動等によって、利用料金の変更の必要が生じたときは、登録ユーザーに対して改定の一ヶ月前までに通知することにより、利用料金を変更することができるものとします。
						</p>
						<p className="paragraph">
							3.
							当社は、本サービスの一部の機能を無料で提供することがありますが、その場合当該機能の無料での提供を将来にわたって保証するものではなく、いつでも第１３条に従い、該当機能を有料にすることができるものとします。
						</p>
						<p className="paragraph">
							4.
							登録ユーザーが利用料金の支払を遅滞した場合には、登録ユーザーは年1４.６％の割合による遅延損害金を当社に支払うものとします。
						</p>
						<p className="paragraph">5. 利用料金の支払いに要する費用は登録ユーザーの負担とします。</p>
						<p className="paragraph">
							6.
							その理由を問わず、本サービス利用期間中に、登録ユーザーが本サービスの提供を受けられなくなった場合または受ける必要がなくなった場合でも、当社は利用料金の返還を行いません。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第７条（利用環境の整備）</h2>
						<p className="paragraph">
							登録ユーザーは、本サービスに利用にあたり、本サービスの利用に必要なインターネット接続環境等の通信手段および機器等を、登録ユーザー自らの責任と費用負担にて準備する必要があることを予め承諾するものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第８条（禁止事項）</h2>
						<p className="paragraph">
							登録ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
						</p>
						<p className="paragraph">
							1.
							本サービスを通じて成立した宿泊予約について、予約者の同意なく宿泊予約を変更・キャンセルする行為
						</p>
						<p className="paragraph">2. 法令または公序良俗に違反する行為</p>
						<p className="paragraph">3. 犯罪行為に関連する行為</p>
						<p className="paragraph">
							4. 当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為
						</p>
						<p className="paragraph">
							5.
							当社、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
						</p>
						<p className="paragraph">
							6.
							当社、本サービスの他の利用者またはその他の第三者のサーバーまたはネットワークの機能を破壊、妨害したり、過度な負担をかける行為
						</p>
						<p className="paragraph">
							7.
							当社が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為
						</p>
						<p className="paragraph">
							8.
							本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を本サービスに掲載すること
						</p>
						<div className="sub">
							<p className="paragraph">8.1 過度に暴力的または残虐な表現を含む情報</p>
							<p className="paragraph">
								8.2 コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
							</p>
							<p className="paragraph">
								8.3
								当社、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報
							</p>
							<p className="paragraph">8.4 過度にわいせつな表現を含む情報</p>
							<p className="paragraph">8.5 差別を助長する表現を含む情報</p>
							<p className="paragraph">8.6 自殺、自傷行為を助長する表現を含む情報</p>
							<p className="paragraph">8.7 薬物の不適切な利用を助長する表現を含む情報</p>
							<p className="paragraph">8.8 反社会的な表現を含む情報</p>
							<p className="paragraph">8.9 他人に不快感を与える表現を含む情報</p>
						</div>
						<p className="paragraph">9. 本サービスに虚偽、または真偽が明らかでない情報を掲載する行為</p>
						<p className="paragraph">10. 本サービスの運営を妨害するおそれのある行為</p>
						<p className="paragraph">
							11. 当社のネットワークまたはシステム等へ不正アクセスをし、またはこれを試みる行為
						</p>
						<p className="paragraph">12. 第三者に成りすます行為</p>
						<p className="paragraph">13. 本サービスの他の登録ユーザーのIDまたはパスワードを利用する行為</p>
						<p className="paragraph">
							14. 本サービスの他の登録ユーザーまたはその他の第三者に不利益、損害、不快感を与える行為
						</p>
						<p className="paragraph">
							15. 当社が許諾しない本サービス上での宣伝、広告、勧誘、または営業行為
						</p>
						<p className="paragraph">
							16. 当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供する行為
						</p>
						<p className="paragraph">17. 前各号の行為を直接または間接に惹起し、または容易にする行為</p>
						<p className="paragraph">18. 前各号の行為を試みること</p>
						<p className="paragraph">19. その他、当社が不適切と判断する行為</p>
					</div>

					<div>
						<h2 className="subTitle">第９条（本サービスの停止等）</h2>
						<p className="paragraph">
							1.
							当社は、以下のいずれかの事由に該当すると判断した場合、登録ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。ただし、本条項に基づき本サービスを停止した場合における損害に対し、当社は一切の責任を負わない。
						</p>
						<div className="sub">
							<p className="paragraph">
								1.1. 本サービスにかかるコンピューター・システムの保守点検または更新を行う場合
							</p>
							<p className="paragraph">
								1.2
								地震、落雷、火災、停電または天災などの不可抗力により、本サービスの運営が困難となった場合
							</p>
							<p className="paragraph">
								1.3
								コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合
							</p>
							<p className="paragraph">
								1.4 その他、当社が本サービスの停止または中断を必要と判断した場合
							</p>
						</div>
					</div>

					<div>
						<h2 className="subTitle">第１０条（権利帰属）</h2>
						<p className="paragraph">
							1.
							当社ウェブサイト上および本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービス利用許諾は、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
						</p>

						<p className="paragraph">
							2.
							登録ユーザーは、掲載データについて、自らが掲載その他送信することについての適法な権利を有していること、および掲載データが第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。
						</p>
						<p className="paragraph">
							3.
							登録ユーザーが掲載したコンテンツ等の著作物について、登録ユーザーは、当社が無償で本サービス以外のウェブサイトや出版物、その他メディア等に、これらの著作物を二次利用（表示・引用・転載等）すること（以下、「本件二次利用」といいます）を許諾するものとします。そして、登録ユーザーは、権利者等から必要な許可を得て、当社が支障なく本件二次利用を行うことができることを保証するものとします。
						</p>
						<p className="paragraph">
							4. 登録ユーザーは前項に定める本件二次利用に対して、著作者人格権を行使しないものとします。
						</p>
						<p className="paragraph">
							5.
							当社は、本サービスを利用して掲載その他送信するコンテンツについて、本サービスの円滑な提供、当社システムの構築・改良・メンテナンス等に必要な範囲内で、変更、切除その他の改変を行うことができるものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１１条（登録抹消等）</h2>
						<p className="paragraph">
							1.
							当社は、登録ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、掲載データを削除もしくは非表示にし、当該登録ユーザーについて本サービスの利用を一時的に停止し、または登録ユーザーとしての登録を抹消することができます。
						</p>
						<div className="sub">
							<p className="paragraph">1.1. 本規約のいずれかの条項に違反した場合</p>
							<p className="paragraph">1.2 登録事項に虚偽の事実があることが判明した場合</p>
							<p className="paragraph">
								1.3
								支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはこれらに類する手続きの開始の申立てがあった場合
							</p>
							<p className="paragraph">1.4 ６ヶ月以上本サービスの利用がない場合</p>
							<p className="paragraph">
								1.5 当社からの問い合わせその他の回答を求める連絡に対して３０日間以上応答がない場合
							</p>
							<p className="paragraph">1.6 第３条第５項各号に該当する場合</p>
							<p className="paragraph">
								1.7
								その他、当社が本サービスの利用または登録ユーザーとしての登録の継続を適当でないと判断した場合
							</p>
						</div>
						<p className="paragraph">
							2.
							前項各号のいずれかの事由に該当した場合、登録ユーザーは、当社に対して追っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１２条（退会）</h2>
						<p className="paragraph">
							1.
							登録ユーザーは、当社所定の手続きの完了により、本サービスから退会し、自己の登録ユーザーとしての登録を抹消することができます。
						</p>
						<p className="paragraph">
							2.
							退会にあたり、当社に対して負っている債務がある場合は、登録ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
						</p>
						<p className="paragraph">
							3. 退会後の利用者情報の取扱いについては、第１６条の規定に従うものとします。
						</p>
						<p className="paragraph">
							4.
							退会時におけるデータのバックアップ等は登録ユーザーの自己責任において行うものとし、当社は解約後のデータの保持についてなんら関与せず、一切の責任を負わないものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１３条（本サービスの内容の変更、終了）</h2>
						<p className="paragraph">
							1. 当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。
						</p>
						<p className="paragraph">
							2. 当社が本サービスの提供を終了する場合、当社は登録ユーザーに事前に通知するものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１４条（保証の否認および免責事項）</h2>
						<p className="paragraph">
							1.
							当社は、本サービスが登録ユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、登録ユーザーによる本サービスに利用が登録ユーザーに適用のある法令または業界団体の内部規制等に適合すること、継続的に利用できること、および不具合が生じないことについて、明示または黙示を問わず何ら保証するものではありません。
						</p>
						<p className="paragraph">
							2.
							当社は、本サービスの利用に際して登録ユーザーが被った損害につき、過去１２ヶ月間に登録ユーザーが当社に支払った対価の金額を超えて賠償する責任は負わないものとし、また、付属的損害、間接損害、特別損害、チャージバックによる損害、将来の損害および逸失利益にかかる損害については、賠償する責任を負わないものとします。
						</p>
						<p className="paragraph">
							3.
							登録ユーザーが、本サービスに関連して第三者（顧客を含む）からクレームを受けまたは第三者との間で紛争が生じた場合は、登録ユーザーは、直ちにその内容を当社に通知すると共に、登録ユーザーの費用と責任において、当該クレームまたは紛争を処理し、その進捗及び結果を当社に報告するものとします。
						</p>
						<p className="paragraph">
							4.
							当社が、登録ユーザーによる本サービスの利用に関連して第三者（顧客を含む）からクレームを受けまたは第三者との間で紛争が生じた場合、登録ユーザーは、登録ユーザーの費用と責任において、当該クレームまたは紛争を処理し、その進捗及び結果を当社に報告すると共に、当社が支払いを余儀なくされた金額その他の損害を賠償するものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１５条（秘密保持）</h2>
						<p className="paragraph">
							1.
							登録ユーザーは、本サービスに関連して当社が登録ユーザーに対して秘密に取扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１６条（利用者情報の取扱い）</h2>
						<p className="paragraph">
							1.
							当社による登録ユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとし、登録ユーザーはこのプライバシーポリシーに従って当社が登録ユーザーの利用者情報を取扱うことについて同意するものとします。
						</p>
						<p className="paragraph">
							2.
							当社は、登録ユーザーが当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用および公開することができるものとし、登録ユーザーはこれに異議を唱えないものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１７条（本規約等の変更）</h2>
						<p className="paragraph">
							1.
							当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の施行時期および内容を当社ウェブサイト上での掲示その他の適切な方法により周知し、または登録ユーザーに通知します。ただし、法令上登録ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法で登録ユーザーの同意を得るものとします。
						</p>
						<p className="paragraph">
							2.
							登録ユーザーが本規約の変更に同意しない場合、登録希望者および登録ユーザーの唯一の対処法は、本サービスを本規約第１２条の定めに基づき退会するのみとなり、当社が前項の通り指定した施行日までに本サービスを退会しない場合、本規約の変更に同意したものとみなします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１８条（連絡・通知）</h2>
						<p className="paragraph">
							1.
							本サービスに関する問い合わせその他登録ユーザーから当社に対する連絡または通知、および本規約の変更に関する通知その他当社から登録ユーザーに対する連絡または通知は、当社の定める方法で行うものとします。
						</p>
						<p className="paragraph">
							2.
							本条第１項における当社からの通知または連絡を電子メールにて行う場合は、当社は、登録ユーザーから、第４条に従った変更届出がない限り、現在登録されている電子メールアドレスへ通知または連絡を行い、これらは、発信時に登録ユーザーへ到達したものとみなします。
						</p>
						<p className="paragraph">
							3.
							本条第１項における当社からの通知または連絡をウェブサイト上で行う場合は、当該通知または連絡をウェブサイトへ掲載した日をもって、登録ユーザーに当該通知等が到達したものとみなします。
						</p>
						<p className="paragraph">
							4.
							登録ユーザーが当社に届け出た登録情報に虚偽、誤記、記載漏れがあり、当社からの通知または連絡が届かなかったことによる損害について当社は一切の責任を負いません。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第１９条（権利義務等の譲渡の禁止）</h2>
						<p className="paragraph">
							1.
							登録ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をするはできません。
						</p>
						<p className="paragraph">
							2.
							当社は本サービスにかかる事業を他者に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約の基づく権利および義務並びに登録ユーザーの登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、登録ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
						</p>
					</div>

					<div>
						<h2 className="subTitle">第２０条（使用許諾）</h2>
						<p className="paragraph">
							1.
							登録ユーザーは、当社が本サービスについて、当社の裁量により、自由にその仕様を変更、または改修することを予め承諾するものとします。
						</p>
						<p className="paragraph">
							2.
							登録ユーザーは、本条第１項の定めに基づく変更または改修後、本サービスに係る仕様説明または当該仕様説明内の表示等が異なる事態が生じることを予め承諾するものとします。
						</p>
						<p className="paragraph">
							3.
							登録ユーザーは、本サービスまたはこれに関連するファイルもしくは資料を、改造、改変、または複製してはなりません。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第２１条（分離可能性）</h2>
						<p className="paragraph">
							本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定および一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
						</p>
					</div>
					<div>
						<h2 className="subTitle">第２２条（準拠法・裁判管轄）</h2>
						<p className="paragraph">
							1. 本規約およびサービス利用契約の解釈にあたっては、日本法を準拠法とします。
						</p>
						<p className="paragraph">
							2.
							本サービスに関して紛争が生じた場合には、京都地方裁判所を第一審の専属的合意管轄裁判所とします。
						</p>
					</div>
					<div className="mt-6 text-right">
						<h3 className="font-semibold">２０２０年 １月 ２２日 制定</h3>
						<h3 className="font-semibold">２０２２年 ７月 ２１日 改定</h3>
						<p>（禁止事項に関して）</p>
						<h3 className="font-semibold">２０２２年 １２月 ２6日 改定</h3>
						<p>（チャージバックに関する記載を追加）</p>
						<h3 className="font-semibold">２０２３年 ４月 ２7日 改定</h3>
						<p>（利用料金に関する記載を追加）</p>
					</div>
				</div>
			</div>
		</PageMeta>
	);
};
